import * as actions from './actions';
import {
    GET_VAULTS,
    GET_LINKED_POOLS,
    SET_VAULTS,
    SET_VAULTS_LOADING_FALSE,
    SET_LINKED_POOLS,
} from './constants';

import { ROLE, Vault } from '@/shared/api/vault';

export type VaultsState = {
    vaults: Vault[];
    linkedPools: {
        [key: string]: Vault[];
    };
    linkedPoolsLoading: boolean;
    vaultsLoading: boolean;
};

export const VaultDefault = {
    address: '',
    curator: '',
    apy: '',
    netApy: '',
    performanceFee: '',
    id: 0,
    icon: '',
    totalSupply: '',
    leverageTokenId: 0,
    role: ROLE.INVESTOR,
    title: '',
    totalDeposited: '',
    description: '',
    collaterals: [''],
    lenders: [''],
    borrowers: [''],
    leverage: {
        id: 0,
        address: '',
        name: '',
        symbol: '',
        balance: '',
        decimals: 0,
    },
    liquidationFee: '',
    liquidationThreshold: '',
    marginCallThreshold: '',
    stressTestMatrix: [{ symbol: '', percent: '', address: '', priceProvider: '', priceModel: '' }],
    totalPosition: '',
    poolBalance: '',
    withdrawable: '',
    interestAccrued: '',
    interestClaimable: '',
    totalBorrowed: '',
    poolUtilization: '0',
};

const defaultState: VaultsState = {
    vaults: [VaultDefault],
    linkedPools: {},
    linkedPoolsLoading: false,
    vaultsLoading: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function vaults(state = defaultState, action: OrderAction): VaultsState {
    switch (action.type) {
        case GET_VAULTS: {
            return {
                ...state,
                vaultsLoading: true,
            };
        }
        case SET_VAULTS: {
            return {
                ...state,
                vaults: action.payload,
                vaultsLoading: false,
            };
        }
        case SET_VAULTS_LOADING_FALSE: {
            return {
                ...state,
                vaultsLoading: false,
            };
        }
        case GET_LINKED_POOLS: {
            return {
                ...state,
                linkedPoolsLoading: true,
            };
        }
        case SET_LINKED_POOLS: {
            return {
                ...state,
                linkedPools: {
                    ...state.linkedPools,
                    [action.payload.vaultAddress]: action.payload.linkedPools,
                },
                linkedPoolsLoading: false,
            };
        }
        default: {
            return state;
        }
    }
}
